//  Helper to convert hex to RGB
const hexToRgb = (hex) => {
  //   const cleanHex = hex.replace("#", "");
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

// Helper to calculate brightness
const getTextColor = (hex) => {
  const { r, g, b } = hexToRgb(hex);
  // relative luminance formula
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? "#000000" : "#ffffff"; // threshold
};

const blendWithWhite10 = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

const blendWithWhite = (hex, opacity = 0.1) => {
  const { r, g, b } = hexToRgb(hex);
  const blended = {
    r: Math.round((1 - opacity) * 255 + opacity * r),
    g: Math.round((1 - opacity) * 255 + opacity * g),
    b: Math.round((1 - opacity) * 255 + opacity * b),
  };
  return `rgb(${blended.r}, ${blended.g}, ${blended.b})`;
};

export { getTextColor, blendWithWhite10, blendWithWhite, hexToRgb };
